import "./Styles/event-detail.scss";
import "../../Assets/Css/Components/cs-toggle.css";
import "@wojtekmaj/react-timerange-picker/dist/TimeRangePicker.css";
import "react-clock/dist/Clock.css";
import _ from "lodash";

import moment from "moment";
import isEmpty from "lodash/isEmpty";
import config from "../../app.json";
import axios from "axios";
import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button } from "react-bootstrap";
import FieldText from "../../Components/Fields/FieldText";
import FieldSelect from "../../Components/Fields/FieldSelect";
import FieldDatepicker from "../../Components/Fields/FieldDatepicker";
import TransmissionProgram from "../../Components/TransmissionProgram/transmission-program";
import Toggle from "react-toggle";
import TimeRangePicker from "../../Components/TimeRangePicker/TimeRangePicker";
import AlertComponent from "../../Components/AlertComponent";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Context } from "../../Reducers/Store";
import FieldUploadMultipart from "../../Components/Fields/FieldUploadMultipart";

import AddNewProgram from "./AddNewProgram";
import AddNewChannel from "./AddNewChannel";
import ModalComponent from "../../Components/ModalComponent";
import SyntaxHighlighter from 'react-syntax-highlighter';
import { shadesOfPurple } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import copy from 'clipboard-copy';

function EventDetail(props) {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const location = useLocation();

  const [state, dispatch] = useContext(Context);
  const [channelName, setChannelName] = useState(null);
  const [eventName, setEventName] = useState("");
  const [hasS3, setHasS3] = useState(null);
  const [step, setStep] = useState(1);
  const [filesLocation, setFilesLocation] = useState("");
  const [recurrent, setRecurrent] = useState(false);
  const [autoStart, setAutoStart] = useState(false);
  const [autoStop, setAutoStop] = useState(false);
  const [fileConvert, setFileConvert] = useState(false);
  const [showCreateNewChannel, setShowCreateNewChannel] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [showAddProgram, setShowAddProgram] = useState(false);
  const [s3Path, setS3Path] = useState(null);

  const [channelsSelected, setChannelsSelected] = useState({});
  const [channelsOptions, setChannelsOptions] = useState([]);
  const [s3LoopVideoGetEvent, setS3LoopVideoGetEvent] = useState({});

  const [startingTimeOptions, setStartingTimeOptions] = useState([]);
  const [startingTimeSelected, setStartingTimeSelected] = useState({
    value: 5,
    label: "5 minutes before",
  });

  const [inputsSelected, setInputsSelected] = useState([]);
  const [outputsSelected, setOutputsSelected] = useState([]);

  const [daysOfWeekSelected, setDaysOfWeekSelected] = useState([]);
  const [calendarDate, setCalendarDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [minTime, setMinTime] = useState(null);
  const [uploading, setUploading] = useState(false);

  const [customStartingLoop, setCustomStartingLoop] = useState(null);
  const [customStartingLoopError, setCustomStartingLoopError] = useState(null);
  const [programItems, setProgramItems] = useState([
    {
      id: 0,
      time: "On Start",
      title: "Starting Loop",
      blocked: true,
      type: "Initial",
    },
  ]);

  const daysOfWeek = [
    { value: 1, label: "Sunday" },
    { value: 2, label: "Monday" },
    { value: 3, label: "Tuesday" },
    { value: 4, label: "Wednesday" },
    { value: 5, label: "Thursday" },
    { value: 6, label: "Friday" },
    { value: 7, label: "Saturday" },
  ];

  let navigate = useNavigate();
  let hlsEndpoint = null;

  const fetchChannels = async () => {
    axios
      .post(config.API + "/api/channel/getChannelsSelect", {
        page: 0,
        perPage: 10,
      })
      .then((res) => {
        if (res.status === 200 && res.data) {
          const channelscbo = res.data.$values.map((x) => {
            return { id: x.id, label: x.name };
          });

          setChannelsOptions(channelscbo);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
            error?.response?.data?.error ||
            error?.message,
          { icon: `error` }
        );
      });
  };

  const fetchEvent = async () => {
    await axios
      .post(config.API + "/api/event/getEvent", {
        id: id,
      })
      .then((res) => {
        if (res.status === 200 && res.data) {
          setData(res.data);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message,
          { icon: `error` }
        );
      });
  };

  const convertTimeApiToApp = (timeString) => {
    if (!timeString) return null;

    const timeArray = timeString.split(":");
    const [hour, minute] = timeArray;
    return `${hour}:${minute}`;
  };

  useEffect(() => {
    if (data) {
      const fetchData = async () => {
        const {
          autoStart,
          autoStop,
          recurrent,
          daysOfWeek: daysOfWeekApi,
          startTime: startTimeApi,
          endTime: endTimeApi,
          specificDate,
          name,
          fileConvert: fileConvertApi,
          s3LoopVideo,
        } = data;

        if (!name) {
          return;
        }

        setAutoStart(autoStart);
        setAutoStop(autoStop);
        setRecurrent(recurrent);
        if (recurrent) {
          const apiDays = daysOfWeekApi.split(", ");
          const filteredDays = daysOfWeek.filter((item) =>
            apiDays.includes(item.label)
          );
          setDaysOfWeekSelected(filteredDays);
        } else {
          setCalendarDate(new Date(specificDate));
        }

        setStartTime(convertTimeApiToApp(startTimeApi));
        setEndTime(convertTimeApiToApp(endTimeApi));
        setEventName(name);
        setStep(2);
        setFileConvert(fileConvertApi);

        if (s3LoopVideo) {
          setS3LoopVideoGetEvent(s3LoopVideo);
          const indexOfUploads = s3LoopVideo.indexOf("/uploads/") + 9;
          const videoName = s3LoopVideo.slice(indexOfUploads + 37);
          const videoGuid = s3LoopVideo.slice(
            indexOfUploads,
            indexOfUploads + 36
          );
          const customVideoLoopFromEvent = {
            name: videoName,
            extension: "mp4",
            type: "video/mp4",
            size: 0,
            guidFile: videoGuid,
          };

          setCustomStartingLoop(customVideoLoopFromEvent);
        }
      };
      fetchData();
    }
  }, [data]);

  useEffect(() => {
    if (!channelsOptions || !channelsOptions.length) {
      return;
    }

    if (!data) {
      return;
    }

    const { channelId } = data;
    const apiChannel = channelsOptions.filter((x) => x.id === channelId);
    if (apiChannel.length) {
      handleChannelSelection(apiChannel[0]);
    }
  }, [channelsOptions, data]);

  useEffect(() => {
    if (!inputsSelected || !inputsSelected.length) {
      return;
    }

    if (!data) {
      return;
    }

    const { switches } = data;
    const { $values } = switches;

    const newPrograms = $values.map((item) => {
      let title = `Event Name`;
      const filteredItem = inputsSelected.filter((x) => x.id === item.inputId);
      if (filteredItem.length) {
        title = `${filteredItem[0].name} - ${filteredItem[0].inputType}`;
      }
      return {
        id: item.inputId,
        time: convertTimeApiToApp(item.startTime),
        title: title,
        blocked: false,
        type: item.inputSwitchType,
      };
    });

    setProgramItems([
      {
        id: 0,
        time: "On Start",
        title: "Starting Loop",
        blocked: true,
        type: "Initial",
      },
      ...newPrograms,
    ]);
    setShowAddProgram(false);
  }, [inputsSelected, data]);

  useEffect(() => {
    const startingTimeOptions = [
      { value: 5, label: "5 minutes before" },
      { value: 10, label: "10 minutes before" },
      { value: 15, label: "15 minutes before" },
    ];

    setStartingTimeOptions(startingTimeOptions);

    fetchChannels();
    if (!isEmpty(id)) {
      fetchEvent();
    }

    if (location?.state?.isView) {
      setReadOnly(location?.state?.isView);
    }
  }, [0]);

  useEffect(() => {
    if (!startingTimeOptions || !startingTimeOptions.length) {
      return;
    }

    if (!data) {
      return;
    }
    const { startMinutes } = data;
    const time = startingTimeOptions.filter((x) => x.value === startMinutes)[0];
    setStartingTimeSelected(time);
  }, [startingTimeOptions, data]);

  useEffect(() => {
    setFilesLocation(
      `s3://cs-${state.church.id}/channel/${channelName}/events/${
        id ? id : "[EVENTID]"
      }/${
        calendarDate ? moment(calendarDate).format("YYYY-MM-DD") + "-HR-MIN" : "[DATE]"
      }/mp4/`
    );
  }, [calendarDate]);

  const handleStepBack = () => {
    if (step !== 3) {
      return AlertComponent("Error", "Invalid action", {
        icon: `error`,
      });
    } else {
      setStep(step - 1);
    }
  };
  const handleStep = () => {
    if (step === 1) {
      if (!inputsSelected.length) {
        return AlertComponent("Error", "Please, select the channel", {
          icon: `error`,
        });
      }
    }

    if (step === 2) {
      if (!recurrent && !calendarDate) {
        return AlertComponent("Error", "Please, select the date", {
          icon: `error`,
        });
      }
      if (recurrent && !daysOfWeekSelected.length) {
        return AlertComponent(
          "Error",
          "Please, select at least one day of week",
          {
            icon: `error`,
          }
        );
      }
      if (!startTime || !endTime) {
        return AlertComponent("Error", "Please, select the time range", {
          icon: `error`,
        });
      }

      if (!programItems || programItems.length < 2) {
        return AlertComponent("Error", "Please, add at least one program", {
          icon: `error`,
        });
      }

      if (
        programItems.length > 2 &&
        programItems[1].time > programItems[2].time
      ) {
        return AlertComponent(
          "Error",
          "Please, adjust the Transmission Program to not allow time overlapping",
          {
            icon: `error`,
          }
        );
      }
    }

    if (step === 3) {
      if (fileConvert && !filesLocation) {
        return AlertComponent(
          "Error",
          "When `File Convert` is toggled on, the file location is required",
          {
            icon: `error`,
          }
        );
      }

      if (!eventName) {
        return AlertComponent("Error", "Event name is required", {
          icon: `error`,
        });
      }

      handleCreateNewEvent();
    }

    if (step < 3) {
      setStep(step + 1);
    }
  };

  const handleCreateNewEvent = async () => {
    let payload = {
      channelId: channelsSelected.id,
      name: eventName,
      startTime: `${startTime}:00`,
      endTime: `${endTime}:00`,
      recurrent: recurrent,
      autoStart: autoStart,
      startMinutes: startingTimeSelected?.value,
      autoStop: autoStop,
      fileConvert: fileConvert && autoStart && hasS3 && autoStop,
    };

    if (id) {
      payload.id = id;
    }

    const customLoopPath = await uploadMp4File();

    if (customLoopPath) {
      payload.s3LoopVideo = customLoopPath;
    }

    if (!recurrent) {
      payload.specificDate = calendarDate;
    } else {
      const daysOfWeekLabel = daysOfWeekSelected.map((x) => {
        return x.label;
      });
      payload.daysOfWeek = daysOfWeekLabel.join(", ");
    }

    if (programItems) {
      const switches = [...programItems];
      switches.splice(0, 1);
      payload.switches = switches.map((x, index) => {
        return {
          inputId: x.id,
          order: index,
          inputSwitchType: x.type,
          startTime: x.time ? `${x.time}:00` : null,
          loop: x.loop,
        };
      });
    }

    await axios
      .post(config.API + "/api/Event/saveEvent", payload)
      .then((res) => {
        if (res.status === 200 && res.data) {
          AlertComponent(
            "Success",
            `The event was successfully ${id ? "edited" : "created"}`
          );
          return navigate("/listingEvents", { replace: false });
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message,
          { icon: `error` }
        );
      });
  };

  const blockFilm = (currentStep) => {
    return currentStep <= step && !readOnly ? "" : "unavailable";
  };

  const blockFilmComponent = () => {
    return !showCreateNewChannel && !readOnly ? "" : "unavailable";
  };

  const handleCreateNew = () => {
    setShowCreateNewChannel(true);
  };

  const handleChannelSelection = async (items) => {
    setChannelName(items?.label);
    setFilesLocation(
      `s3://cs-${state.church.id}/channel/${items?.label}/events/${
        id ? id : "[EVENTID]"
      }/${
        calendarDate ? moment(calendarDate).format("YYYY-MM-DD") + "-HR-MIN" : "[DATE]"
      }/mp4/`
    );

    setChannelsSelected(items);
    await axios
      .post(config.API + "/api/channel/getChannel", {
        id: items.id,
      })
      .then((res) => {
        if (res.status === 200 && res.data) {
          const outputsApi = res.data.outputs.$values;
          setInputsSelected(res.data.inputs.$values);
          setOutputsSelected(outputsApi);
          const hasAnyS3 = outputsApi.some((x) => x.s3Path != null);
          setHasS3(hasAnyS3);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message,
          { icon: `error` }
        );
      });
  };

  const handleDaysOfWeekSelection = (items) => {
    setDaysOfWeekSelected(items);
  };

  const handleRecurrent = () => {
    setRecurrent(!recurrent);
  };

  const handleAutoStart = () => {
    setAutoStart(!autoStart);
  };

  const handleAutoStop = () => {
    setAutoStop(!autoStop);
  };

  const handleFileConvert = () => {
    setFileConvert(!fileConvert);
  };

  const customAddFiles = (prop) => (
    <aside style={thumbsContainer}>
      <div>
        <div style={thumbInner} {...prop}>
          <Button type="button" align="center">
            Drop your mp4 file
          </Button>
        </div>
      </div>
    </aside>
  );

  const handleAddNewChannel = async (item) => {
    const itemSelect = { id: item.id, label: item.name };
    handleChannelSelection(itemSelect);

    setShowCreateNewChannel(false);
    await fetchChannels();
  };

  const handleAddNewProgram = (program) => {
    const newProgramItems = [...programItems, program];
    setProgramItems(newProgramItems);
    setShowAddProgram(false);
  };

  const handleShowAddNewProgram = () => {
    if (programItems.length == 1) {
      setMinTime(startTime);
    } else {
      const lastFixedTime = programItems
        .filter((x) => x.type === "FixedTime")
        ?.at(-1);
      if (lastFixedTime) {
        const newTime = moment(lastFixedTime.time, "HH:mm")
          .add(1, "minute")
          .format("HH:mm");
        setMinTime(newTime);
      } else {
        setMinTime(startTime);
      }
    }
    setShowAddProgram(true);
  };

  const uploadMp4File = async () => {
    if (uploading)
      return AlertComponent(
        "Error",
        "Your upload is in progress. Please wait it to finish before continue.",
        { icon: `error` }
      );

    if (customStartingLoop) {
      // It means that it was loaded from https://api-dev.churchstreaming.app/api/event/getEvent. Check setS3LoopVideoGetEvent
      if (customStartingLoop.size === 0) {
        return s3LoopVideoGetEvent;
      }

      let mp4File = null;
      await axios
        .post(config.API + "/api/file/s3Upload", customStartingLoop)
        .then((res) => {
          mp4File = res.data;
          setS3Path(mp4File);
        })
        .catch(function (error) {
          return AlertComponent(
            "Error",
            error?.response?.data?.error || error?.message,
            { icon: `error` }
          );
        });

      return mp4File;
    }
    return null;
  };

  // const uploadMp4File = async (formData, optionsUpload) => {
  //   let mp4File = null;
  //   await axios
  //     .post(config.API + "/api/file/s3Upload", formData, optionsUpload)
  //     .then((res) => {
  //       mp4File = res.data;
  //       setS3Path(mp4File);
  //     })
  //     .catch(function (error) {
  //       return AlertComponent(
  //         "Error",
  //         error?.response?.data?.error ||
  //         error?.response?.data?.message ||
  //         error?.message,
  //         { icon: `error` }
  //       );
  //     });
  //   return mp4File;
  // };

  const handleRemoveSwitch = async (index) => {
    if (index === 0) {
      return;
    }

    if (programItems.length > 2 && index === 1) {
      if (programItems[2].type !== `FixedTime`) {
        return AlertComponent(
          "Error",
          "The item after `On Start` must be `Fixed Time`",
          { icon: `error` }
        );
      }
    }
    const newProgramItems = [...programItems];
    newProgramItems.splice(index, 1);
    setProgramItems(newProgramItems);
  };

  const updateProgramItems = (newValue) => {
    setProgramItems((oldList) => {
      const newList = [...oldList];
      newList[1].time = newValue;
      return newList;
    });
  };

  const handleStartTime = (value) => {
    setStartTime(value);
    if (programItems.length > 1) {
      updateProgramItems(value);
    }
  };

  const copyToClipboard = () => {
    return navigator.clipboard.writeText(hlsEndpoint);
  };

  const livePlayerEmbedCode = `<!-- Start Church Streaming Live Player -->

<script
    type="text/javascript"
    data-cs="${config.API}"
    src="${config.API}/js/churchstreaming-live.js?eventId=${id}">
</script>

<!-- End Church Streaming Live Player -->`;

  const livePlayerIframeCode = `<iframe
    src="${config.API}/live-preview.html?eventId=${id}"
    style="width:100%;aspect-ratio:16/9;border:none;border-radius:12px;"
    allow="autoplay; fullscreen; picture-in-picture"
    allowfullscreen>
</iframe>`;

  return (
    <Row>
      <Col md={11}>
        <ModalComponent
          data={
            <div className="modal-container">
              <AddNewChannel
                onAdd={handleAddNewChannel}
                id={data?.channelId || channelsSelected?.id}
              />
            </div>
          }
          modalIsOpen={showCreateNewChannel}
          setModalIsOpen={setShowCreateNewChannel}
        />

        <ModalComponent
          data={
            <div className="modal-container">
              <AddNewProgram
                firstItem={programItems.length == 1}
                inputs={inputsSelected}
                handleAdd={handleAddNewProgram}
                startTime={!minTime ? startTime : minTime}
                minTime={minTime}
              />
            </div>
          }
          modalIsOpen={showAddProgram}
          setModalIsOpen={setShowAddProgram}
        />
        <Row className={`event-detail mb-4 mt-4`}>
          <Col className={`col-md-12 ${blockFilmComponent()}`}>
            <div className="cc-card">
              <FieldText
                label="Event Name"
                type="text"
                onChange={(x) => setEventName(x.target.value)}
                placeholder="Event Name"
                value={eventName}
                className="col-md-12"
                required={true}
                inputClassName={`inputOption`}
              />
            </div>
          </Col>
        </Row>
        <Row className="event-steps">
          <Col className={`col-md-4 ${blockFilm(1)} ${blockFilmComponent()}`}>
            <div className="cc-card">
              <div className="cc-card-header">
                <h5>Channel</h5>
                <div onClick={handleCreateNew}>Create New</div>
              </div>
              <Row className="align-content-center gx-3">
                <Col md={10}>
                  <FieldSelect
                    label={`Select Channel`}
                    options={channelsOptions}
                    id={`select_channel`}
                    name={`select_channel`}
                    onChange={handleChannelSelection}
                    value={channelsSelected}
                    multiple={false}
                  />
                </Col>
                <Col md={2}>
                  <div className="form-group refresh-button-container">
                    <Button
                      type="button"
                      className="big-edit-btn"
                      onClick={handleCreateNew}
                    >
                      &nbsp;
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <label htmlFor="inputs">Inputs</label>
                    <div className="inputs" id="inputs">
                      {inputsSelected?.map((x, index) => {
                        return (
                          <div className="" key={"input_" + x.id}>
                            <div className="inputs-elements item">
                              {`${x.name} - ${x.inputType}`}
                            </div>
                          </div>
                        );
                      })}
                      {inputsSelected.length == 0 && (
                        <div className="inputs-elements">None</div>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
              {inputsSelected
                ?.filter((x) => x.inputType === `RTMP`)
                .map((x) => (
                  <Row key={"rtmp_push_url_" + x.id}>
                    <Col md={12}>
                      <FieldText
                        label={`${x.name} Push URL`}
                        type="text"
                        placeholder="Archive Destination"
                        value={x.rtmpLink}
                        className="col-md-12"
                        required={true}
                        inputClassName={`inputOption`}
                        readonly={true}
                        // onChange={() => console.log("")}
                      />
                    </Col>
                  </Row>
                ))}
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <label htmlFor="outputs">Outputs</label>
                    <div className="outputs" id="outputs">
                      {outputsSelected?.map((x) => (
                        <div
                          className="outputs-elements item"
                          key={"output_" + x.id}
                        >
                          {`${x.name} - ${x.outputType}`}
                        </div>
                      ))}

                      {outputsSelected.length == 0 && (
                        <div className="outputs-elements">None</div>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>

              {outputsSelected?.some(
                (x) => x.outputType === `MediaPackage`
              ) && (
                <Row className="gx-3">
                  <Col md={10}>
                    {outputsSelected
                      ?.filter((x) => x.outputType === `MediaPackage`)
                      .map((x) => {
                        hlsEndpoint = x.hlsEndpoint;
                        return (
                          <FieldText
                            label="HLS Link Cloudfront"
                            type="text"
                            placeholder="HLS Link Cloudfront"
                            value={x.hlsEndpoint}
                            inputClassName={`inputOption`}
                            readonly={true}
                            key={"mediapackage_" + x.id}
                            // onChange={() => console.log("changed")}
                          />
                        );
                      })}
                  </Col>
                  <Col md={2}>
                    <div className="form-group refresh-button-container">
                      <Button
                        type="button"
                        className="big-copy-btn"
                        onClick={copyToClipboard}
                      >
                        &nbsp;
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}

              {id && outputsSelected?.some(
                (x) => x.outputType === `MediaPackage`
              ) && (
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label>Watch live player</label>
                      <iframe
                        title="Live Player Preview"
                        src={`${config.API}/live-preview.html?eventId=${id}`}
                        allow="autoplay; fullscreen; picture-in-picture"
                        style={{ width: "100%", aspectRatio: "16 / 9", border: "none", borderRadius: 12, display: "block" }}
                      />
                      <small className="form-text text-muted">
                        Preview: fullscreen, cast, airplay, and picture in picture are built in.
                      </small>
                    </div>
                    <div className="form-group">
                      <label>Embed code</label>
                      <SyntaxHighlighter
                        className="code-box"
                        language="cshtml"
                        style={shadesOfPurple}
                        showLineNumbers={false}
                        customStyle={{ maxHeight: 220 }}
                      >
                        {livePlayerEmbedCode}
                      </SyntaxHighlighter>
                      <Button
                        className="dark-btn"
                        type="button"
                        onClick={() => {
                          copy(livePlayerEmbedCode);
                          return AlertComponent("Success", "Code copied successfully!");
                        }}
                      >
                        Copy Code
                      </Button>
                    </div>
                    <div className="form-group">
                      <label>Embed code (iframe)</label>
                      <small className="form-text text-muted" style={{ marginTop: 0, marginBottom: 8 }}>
                        Use this version on platforms that block scripts (site builders, Church Online Platform, Wix, etc).
                      </small>
                      <SyntaxHighlighter
                        className="code-box"
                        language="cshtml"
                        style={shadesOfPurple}
                        showLineNumbers={false}
                        customStyle={{ maxHeight: 180 }}
                      >
                        {livePlayerIframeCode}
                      </SyntaxHighlighter>
                      <Button
                        className="dark-btn"
                        type="button"
                        onClick={() => {
                          copy(livePlayerIframeCode);
                          return AlertComponent("Success", "Code copied successfully!");
                        }}
                      >
                        Copy iframe Code
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}

              {outputsSelected
                ?.filter((x) => x.outputType === `S3`)
                .map((x) => (
                  <Row key={"s3_" + x.id}>
                    <Col md={12}>
                      <FieldText
                        label="Archive Destination"
                        type="text"
                        placeholder="Archive Destination"
                        value={x.s3Path}
                        className="col-md-12"
                        required={true}
                        inputClassName={`inputOption`}
                        readonly={true}
                        // onChange={() => console.log("changed")}
                      />
                    </Col>
                  </Row>
                ))}
              <Row>
                {!readOnly && (
                  <Col md={12} className="d-flex justify-content-end">
                    <ButtonNext
                      className="dark-btn"
                      handleStep={handleStep}
                      step={step}
                      currentStep={1}
                    />
                  </Col>
                )}
              </Row>
            </div>
          </Col>

          <Col className={`col-md-4 ${blockFilm(2)}`}>
            <div className="cc-card">
              <h5>Schedule</h5>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <div className="recurrency">
                      <label>Recurrent</label>
                      <Toggle
                        checked={recurrent}
                        onClick={handleRecurrent}
                        className="form-group"
                        disabled={step !== 2}
                        // onChange={() => console.log("-")}
                      />
                    </div>
                    <small className="small-info">
                      For recurrent events select the days of the week.
                    </small>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="single-date-picker">
                    <FieldDatepicker
                      label={`Date`}
                      className={`datepicker ${!recurrent ? "" : "d-none"}`}
                      placeholder={`Date`}
                      value={calendarDate}
                      onChange={setCalendarDate}
                      startDate={calendarDate}
                      disabled={step !== 2}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="day-weeks-picker">
                    <FieldSelect
                      label={`Days of Week`}
                      options={daysOfWeek}
                      className={`${recurrent ? "" : "d-none"}`}
                      id={`inputs`}
                      name={`inputs`}
                      onChange={handleDaysOfWeekSelection}
                      value={daysOfWeekSelected}
                      multiple={true}
                      readonly={step !== 2}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className={`form-group`}>
                    <TimeRangePicker
                      setStartTime={handleStartTime}
                      setEndTime={setEndTime}
                      startTime={startTime}
                      endTime={endTime}
                      readOnly={step !== 2}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col md={12}>
                  <h5>Pre-live video loop</h5>
                  <FieldUploadMultipart
                    onUploadComplete={(u) => setCustomStartingLoop(u)}
                    accept={["video/mp4"]}
                    label={"Upload Custom Loop"}
                    maxSize={4 * 1024 * 1024 * 1024} // 4 GB
                    required={true}
                    error={customStartingLoopError}
                    onStateChanged={setUploading}
                    className="upload-video-w-progress mb-0"
                    disabled={step !== 2}
                    data={customStartingLoop}
                  />
                  <div className="small-info">
                    This video loop will be displayed before your schedule. If
                    you don't upload one, we will use our unbranded standole
                    video loop.
                  </div>
                </Col>
              </Row>
              {step === 2 && (
                <Row className="mt-4">
                  <Col md={12}>
                    <div className="schedule-header">
                      <h5>Transmission Program</h5>
                      <div onClick={handleShowAddNewProgram}>Add Program</div>
                    </div>
                  </Col>
                </Row>
              )}
              <Row>
                <Col md={12}>
                  <TransmissionProgram
                    blockRemove={step !== 2}
                    items={programItems}
                    handleRemoveSwitch={handleRemoveSwitch}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12} className="d-flex justify-content-end">
                  {!readOnly && (
                    <ButtonNext
                      className="dark-btn"
                      handleStep={handleStep}
                      step={step}
                      currentStep={2}
                    />
                  )}
                </Col>
              </Row>
            </div>
          </Col>

          <Col className={`col-md-4 ${blockFilm(3)}`}>
            <div className="cc-card">
              <h5>Automation</h5>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <div className="recurrency">
                      <label>Auto-start Channel?</label>
                      <Toggle
                        checked={autoStart}
                        onClick={handleAutoStart}
                        className="form-group"
                        // onChange={() => console.log("-")}
                      />
                    </div>
                    <div className="small-info">
                      When auto-start is active, your channel will start with a
                      initial video loop until your schedule takes place.
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  {autoStart && (
                    <FieldSelect
                      label={`Starting time`}
                      options={startingTimeOptions}
                      className={`col-md-12`}
                      id={`startingTime`}
                      name={`startingTime`}
                      value={startingTimeSelected}
                      multiple={false}
                      placeholder={`Choose Channel`}
                      onChange={setStartingTimeSelected}
                    />
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  {autoStart && (
                    <div className="form-group col-md-12">
                      <div className="recurrency">
                        <label>Auto-stop Channel?</label>
                        <Toggle
                          checked={autoStop}
                          onClick={handleAutoStop}
                          className="form-group"
                          // onChange={() => console.log("-")}
                        />
                      </div>
                      {hasS3 && (
                        <div className="small-info">
                          When auto-start is active, you can enable the auto
                          conversion.
                        </div>
                      )}
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  {autoStart && hasS3 && autoStop && (
                    <div className="form-group col-md-12">
                      <div className="recurrency">
                        <label>File Convert</label>
                        <Toggle
                          // checked={fileConvert}
                          onClick={handleFileConvert}
                          className="form-group"
                          checked={fileConvert}
                          // onChange={() => console.log("-")}
                        />
                      </div>
                      <div className="small-info">
                        An MP4 and M3U8 files will be generated after the event
                        is done.
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  {autoStart && hasS3 && autoStop && fileConvert && (
                    <FieldText
                      label="Files location"
                      type="text"
                      placeholder="s3://church-streaming-test/test/"
                      value={fileConvert ? filesLocation : ``}
                      className="col-md-12"
                      inputClassName={`inputOption`}
                      disabled={true}
                      readonly={true}
                      // onChange={() => console.log("changed")}
                    />
                  )}
                </Col>
              </Row>
              {!readOnly && (
                <Row className="justify-content-end">
                  <Col md={6} className="mt-4 go-back-btn">
                    <ButtonNext
                      handleStep={handleStepBack}
                      step={step}
                      currentStep={3}
                      text={`Back`}
                    />
                  </Col>
                  <Col md={6} className="d-flex justify-content-end mt-4">
                    <ButtonNext
                      handleStep={handleStep}
                      step={step}
                      currentStep={3}
                      text={`Save`}
                      className="col-right"
                    />
                  </Col>
                </Row>
              )}
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mb-5 mt-5"></Col>
        </Row>
      </Col>
    </Row>
  );
}

export default EventDetail;

function ButtonNext(props) {
  const { step, handleStep, currentStep, text = `Next` } = props;
  return (
    <div className={`next-button step-${currentStep}`}>
      <div className={`${step != currentStep ? "d-none" : ""}`}>
        <Button
          className="dark-btn"
          type="submit"
          align="center"
          onClick={handleStep}
          disabled={step != currentStep}
        >
          {text}
        </Button>
      </div>
    </div>
  );
}
